/* ==========================================================================
   Joy Loyalty Rewards Page — Shared JavaScript Utilities
   ========================================================================== */

(function () {
  'use strict';

  window.JoyLoyalty = window.JoyLoyalty || {};

  /**
   * Wait for Joy SDK to be ready, then invoke callback with joyInstance.
   * If SDK is already loaded, fires immediately.
   */
  JoyLoyalty.onJoyReady = function (callback) {
    if (window.joyInstance) {
      callback(window.joyInstance);
      return;
    }
    window.addEventListener('joy:ready', function () {
      if (window.joyInstance) {
        callback(window.joyInstance);
      }
    });
  };
  
  /**
   * Redirect customers back to the current page after login.
   */
  JoyLoyalty.registerLoginRedirect = function (joy) {
    joy.registerRedirectGuest(function (type) {
      if (type !== 'login') return;

      var returnTo =
        window.location.pathname +
        window.location.search +
        window.location.hash;

      window.location.href =
        'https://9cb8e7-2.myshopify.com/customer_authentication/login?return_to=' +
        encodeURIComponent(returnTo);
    });

    console.log('Joy custom login redirect registered');
  };

  JoyLoyalty.onJoyReady(function (joy) {
    JoyLoyalty.registerLoginRedirect(joy);
  });
})();
